<template lang='pug'>
.guide-container
    img.base-banner(
        v-src="'https://oss.cloud.custouch.com/res/11272/助剂指南@3x.png'",
    )
    .content
        h4 {{ title }}
        div 使用免费助剂指南App软件了解毕克化学的助剂世界。该App软件是为向您提供最新的毕克化学助剂信息而设计的。<br><br>访问我们最新的产品信息，按应用浏览我们的助剂推荐，并获得所有相关的产品数据。所有数据页下载后都支持离线操作。这款App提供德语、英语、中文和韩文的界面语言。
        img.qrcode(
            v-src="'https://oss.cloud.custouch.com/res/132969/APP_microQr_20221031.jpg'"
        )
        .tip iOS 和 Android 用户扫码一键安装
</template>

<script>
export default {
    props: ['title'],
}
</script>

<style scoped lang='less'>
.guide-container {
    font-size: 0.75rem;
    user-select: none;
}
h4{
    font-size: 1.2em;
}
.content {
    padding: 1rem;
}
.qrcode {
    width: 6rem;
    object-fit: contain;
    margin: 2rem auto 0.6rem;
    display: block;
}
.tip{
    text-align: center;
}
</style>